<template>
    <BaseBoxSection :helpName="helpPrefix + '-002'" :title="__('buyer-recipient')">
        <div :class="{'has-error': hasError('contractor')}" class="col-md-4">
            <label>{{ __('company_name_or_first_name_and_second_name') }}{{
                    isRequiredDesignation('contractor')
                }}</label>
            <select2
                :disabled="disabled"
                :settings="{ width: '100%' }"
                :options="contractorsOptions"
                :value="contractor"
                @input="contractorChanged"
            />

            <InputErrors :errors="getErrors('contractor')"/>
        </div>

        <div class="col-md-2">
            <label>{{ __('country') }}</label>
            <input :value="selectedContractor.country" class="form-control" disabled type="text">
        </div>

        <div class="col-md-2">
            <label>{{ __('identification_number_id') }}</label>
            <input :value="selectedIdNumberType" class="form-control" disabled type="text">
        </div>

        <div :class="{'has-error': hasError('contractor_id_number')}" class="col">
            <label>{{ __('identification_number') }}{{ isRequiredDesignation('contractor') }}</label>
            <select2
                :disabled="disabled"
                :settings="{ width: '100%' }"
                :options="idNumbersOptions"
                :value="selectedIdNumber"
                @input="contractorChangedByIdNumber"
            />
            <InputErrors :errors="getErrors('contractor_id_number')"/>
        </div>
        <div class="col-md-auto" v-if="type.type_name == 'invoicing_pl_VAT' || type.type_name == 'invoicing_pl_margin'">
            <div class="input-group m-l-xs m-r-xs m-b-xs m-t-sm"><label class=" disabled-label"><input type="checkbox"
                                                                                                       readonly="readonly"
                                                                                                       class="mt-3 protect-unsaved-changes disabled-checkbox&quot;"
                                                                                                       v-model="contractor_vies">
                VIES </label></div>
        </div>

        <div class="col-md-6">
            <div class="row m-b-sm">
                <div class="col-md-12 m-b-sm">
                    <label>{{ __('full_address') }}</label>
                    <input :value="selectedContractor.address" class="form-control" disabled type="text">
                </div>
                <div class="col-md-12 m-b-sm">
                    <input :value="selectedContractor.address_2" class="form-control" disabled type="text">
                </div>
                <div class="col-md-6 m-b-sm">
                    <label>{{ __('zip') }}</label>
                    <input :value="selectedContractor.zip" class="form-control" disabled type="text">
                </div>
                <div class="col-md-6 m-b-sm">
                    <label>{{ __('city') }}</label>
                    <input :value="selectedContractor.city" class="form-control" disabled type="text">
                </div>
            </div>
        </div>
        <div class="col-md-6">
            <div class="form-group">
                <label>{{ __('remarks') }}</label>
                <textarea
                    :value="selectedContractor.remarks"
                    class="form-control"
                    disabled
                    style="height:126px;"
                    type="text"></textarea>
            </div>
        </div>

        <div class="col-md-12">
            <a v-if="contractor > 0 && getPermission('contractors_preview') && showButtons.show" class="btn btn-primary"
               @click="$emit('contractorButtons', 'show', contractor)">
                <i class="fa fa-eye"></i> {{ __('contractor_show') }}
            </a>
            <a v-if="contractor > 0 && getPermission('editing_contractors') && showButtons.edit" class="btn btn-primary"
               @click="$emit('contractorButtons', 'edit', contractor)">
                <i class="fa fa-pen"></i> {{ __('contractor_edit') }}
            </a>
            <a v-if="getPermission('adding_contractors') && showButtons.create" class="btn btn-primary"
               @click="$emit('contractorButtons', 'add')">
                <i class="fa fa-plus"></i> {{ __('contractors_add') }}
            </a>
        </div>
        <div class="col-md-12 m-b-xs mt-2" v-if="type.country_code">
            <label>
                <input
                    :checked="hasMatchedJst"
                    :disabled="contractor === -1 || mode =='show'"
                    type="checkbox"
                    @change="handleMatchedJstChange"
                > {{ __('contract_for_matched_jst') }}
            </label>
            <label>
                <input
                    :checked="hasMatchedGv"
                    :disabled="contractor === -1 || mode =='show'"
                    type="checkbox"
                    @change="handleMatchedGvChange"
                > {{ __('contract_for_matched_gv') }}
            </label>
        </div>
        <div class="col-md-12 m-b-xs mt-2">
            <label>
                <input
                    :checked="hasRecipient"
                    :disabled="contractor === -1 || mode =='show'"
                    type="checkbox"
                    @change="handleHasRecipientChange"
                > {{ __('recipient-data-show') }}
            </label>
        </div>

        <RecipientForm
            v-if="hasRecipient"
            :countries="countries"
            :disabled="mode =='show'"
            :errors="errors"
            :idNumbers="idNumbers"
            :recipient="recipient"
            :requiredFields="requiredFields"
            :selectedContractor="selectedContractor"
            :type="type"
            @inputs="$emit('recipientInputs', $event)"
            @assignRecipient="$emit('assignRecipient', $event)"
            @resetRecipient="$emit('resetRecipient')"
        />
        <OtherEntity
            v-if="type.type_name == 'invoicing_pl_VAT' || type.type_name == 'invoicing_pl_margin'"
            :otherEntitiesTypes="otherEntitiesTypes"
            :otherEntities="otherEntities"
            @addNewOtherEntity="$emit('addNewOtherEntity')"
            :disabled="disabledOtherEntity"
            :errors="errors"
            :type="type"
            :requiredFields="requiredFields"
            :contractors="contractors"
            :original-company="originalCompany"
            @otherEntityInput="$emit('otherEntityInput', $event)"
            @removeOtherEntity="$emit('removeOtherEntity', $event)">


        </OtherEntity>

    </BaseBoxSection>
</template>

<script>
import BaseBoxSection from "../BaseBoxSection";
import inputEmit from "../../mixins/inputEmit";
import hasErrors from "../../mixins/hasErrors";
import InputErrors from "../form/InputErrors";
import hasPermissions from "../../mixins/hasPermissions";
import RecipientForm from "./RecipientForm";
import hasRequiredFields from "../../mixins/hasRequiredFields";
import OtherEntity from "./OtherEntity";
import {forEach} from "lodash";

export default {
    name: "ContractorBox",
    components: {OtherEntity, RecipientForm, InputErrors, BaseBoxSection},
    mixins: [inputEmit, hasErrors, hasPermissions, hasRequiredFields],
    data() {
        return {
            contractor_vies: false,

        };
    },
    props: {
        originalCompany: {
            type: Object,
            default: () => {},
        },
        contractors: {
            type: Array,
            default: () => [],
        },
        mode: {
            type: String,
            required: true,
        },
        contractor: {
            type: Number,
            default: -1,
        },
        idNumber: {
            type: Number,
            default: 0,
        },
        hasRecipient: {
            type: Boolean,
            default: false,
        },
        hasMatchedJst: {
            type: Boolean,
            default: false,
        },
        hasMatchedGv: {
            type: Boolean,
            default: false,
        },
        forceVies: {
            type: Boolean,
            default: false,
        },
        recipient: {
            type: Object,
            required: true,
        },
        countries: {
            type: Array,
            default: () => [],
        },
        idNumbers: {
            type: Array,
            default: () => [],
        },
        disabled: {
            type: Boolean,
            default: false,
        },
        disabledOtherEntity: {
            type: Boolean,
            default: false,
        },
        helpPrefix: {
            type: String,
            default: '',
        },
        showButtons: {
            type: Object,
            required: true,
        },
        type: {
            type: Object,
            required: true,
        },
        otherEntitiesTypes:{
            type: Array,
            default: () => [],
        },
        otherEntities:{
            type: Array,
            default: () => [],
        }
    },
    methods: {
        handleMatchedJstChange(){

            this.emitInput('for_matched_jst', event.target.checked)
            this.$emit('setJst');
        },
        handleMatchedGvChange(){

            this.emitInput('for_matched_gv', event.target.checked)
            this.$emit('setGv');
        },
        handleHasRecipientChange(event) {
            this.$emit('setRecipient', this.selectedContractor,this.idNumber);
            this.emitInput('has_recipient', event.target.checked)
        },
        setVies() {
            if (this.contractor !== -1) {
                const contractor = this.getContractor(this.contractor);
                if ((this.idNumber === 1 && !contractor.vies) || (this.idNumber === 2 && !contractor.second_vies)) {
                    const idNumber = this.getViesIdNumber(contractor);

                    if (idNumber) {
                        this.emitInput('contractor_id_number', idNumber);
                        this.handleContractorVies(idNumber, contractor)
                    }
                }
            }
            var entity = this.otherEntities.find(entity => entity.document_other_entity_type_id == 2);
            if(entity){
                if(this.originalCompany.number_type_vies){
                    entity.vies = this.originalCompany.number_type_vies;
                    entity.contractor_id_number_selected = 1;
                    entity.number_type = this.__(this.originalCompany.number_type)
                    $('.select-number-other-entity').find('#select2--container').html(this.originalCompany.identification_number)

                }
                else if(this.originalCompany.number_type_secondary_vies){
                    entity.vies = this.originalCompany.number_type_secondary_vies;
                    entity.contractor_id_number_selected = 2;
                    entity.number_type = this.__(this.originalCompany.number_type_secondary)
                    $('.select-number-other-entity').find('#select2--container').html(this.originalCompany.secondary_identification_number)
                }
            }
            var otherEntities = this.otherEntities.filter(entity => entity.document_other_entity_type_id != 2);
            const _this = this;
            if(otherEntities){
                otherEntities.forEach(function(entity){
                    var contractor = _this.contractors.find(contractor => contractor.id == entity.contractor_id);
                    if(contractor.vies){
                        entity.vies = true;
                        entity.contractor_id_number_selected = 1;
                        entity.number_type = _this.__(contractor.id_number_type)
                    }
                    if(contractor.second_vies){
                        entity.vies = true;
                        entity.contractor_id_number_selected = 2;
                        entity.number_type = _this.__(contractor.second_id_number_type)
                    }
                })
            }

        },
        getViesIdNumber(contractor) {
            if (contractor.vies) {
                return 1;
            } else if (contractor.second_vies) {
                return 2;
            }

            return null;
        },
        getContractor(id) {
            return this.contractors.find(c => c.id === id) || {};
        },
        contractorChanged(value, ignoreIdNumber = false) {
            const contractorId = parseInt(value);

            this.emitInput('contractor', contractorId);
            if (!ignoreIdNumber) {
                const idNumber = contractorId === -1 ? 0 : 1;
                this.emitInput('contractor_id_number', idNumber);
            }

            this.$store.dispatch('removeIfExistAlert', 'contractor_completed')
            this.$store.dispatch('removeIfExistAlert', 'jst_other_entity_alert_warning');
            this.$store.dispatch('removeIfExistAlert', 'gv_other_entity_alert_warning');
            this.$store.dispatch('removeIfExistAlert', 'jst_other_entity_alert_danger');
            this.$store.dispatch('removeIfExistAlert', 'vat_other_entity_alert_danger');
            this.emitInput('for_matched_jst', false)
            this.emitInput('for_matched_gv', false)
            if (contractorId === -1) this.emitInput('has_recipient', false);
            else {
                const contractor = this.getContractor(contractorId);

                this.handleContractorCompleteAlert(contractor);
                this.jstOtherEntityAlertWarning(contractor);
                this.gvOtherEntityAlertWarning(contractor)
                this.$emit('setRecipient', contractor);
                this.handleContractorVies(1, contractor)
            }
            if(this.forceVies){
                const _this = this;
                setTimeout(function (){
                    _this.setVies()
                }, 500)
            }

        },
        handleContractorCompleteAlert(contractor) {
            if (!contractor.is_complete) {
                this.$store.dispatch('addAlert', {
                    name: 'contractor_completed',
                    alert: {
                        type: 'error',
                        title: this.__('warning'),
                        msg: this.__('the_selected_contractor_is_to_be_completed_error'),
                    },
                });
            }
        },
        jstOtherEntityAlertWarning(contractor) {
            if (contractor && contractor.remind_jst  && !this.hasMatchedJst) {
                this.$store.dispatch('addAlert', {
                    name: "jst_other_entity_alert_warning",
                    alert: {
                        type: 'warning',
                        title: this.__('warning'),
                        msg: this.__('jst_contract_alert_warning'),
                    },
                });
            }
        },
        gvOtherEntityAlertWarning(contractor) {
            if (contractor && contractor.remind_gv  && !this.hasMatchedGv) {
                this.$store.dispatch('addAlert', {
                    name: "gv_other_entity_alert_warning",
                    alert: {
                        type: 'warning',
                        title: this.__('warning'),
                        msg: this.__('gv_contract_alert_warning'),
                    },
                });
            }
        },
        contractorChangedByIdNumber(value) {
            if (typeof value === 'string') {
                let idParts = value.split('-');
                let contractorId = parseInt(idParts[0]);
                let numberId = parseInt(idParts[1]);

                contractorId = contractorId === 0 ? -1 : contractorId;

                if (this.contractor === contractorId) {
                    this.emitInput('contractor_id_number', numberId);
                    this.handleContractorVies(numberId)
                } else {
                    this.contractorChanged(contractorId, true);
                    this.emitInput('contractor_id_number', numberId);
                    setTimeout(()=>{
                        this.handleContractorVies(numberId)
                    }, 500)

                }
                if(this.forceVies){
                    const _this = this;
                    setTimeout(function (){
                        _this.setVies()
                    }, 500)

                }
            }
        },
        handleContractorVies(numberId, contractor = null){
            if(this.type.type_name == 'invoicing_pl_VAT' || this.type.type_name == 'invoicing_pl_margin')
            {
                if(contractor == null){
                    contractor = this.selectedContractor
                }
                if(numberId == 1 && contractor.vies){
                    this.contractor_vies = true;
                }
                else if(numberId == 2 && contractor.second_vies){
                    this.contractor_vies = true;
                }
                else{
                    this.contractor_vies = false;
                }
            }
            else{
                this.contractor_vies = false;
            }

        }
    },
    computed: {
        hasWarning() {
            return this.selectedContractor.is_complete === false;
        },
        contractorsOptions() {
            let contractors = this.contractors.filter(function(contractor){
                return contractor.global_account == 0;
            })
            let options = contractors.map((option) => ({text: option.name, id: option.id}));
            options.unshift({text: '---', id: -1});

            return options;
        },
        selectedContractor() {
            return this.contractors.find(c => c.id === this.contractor) || {};
        },
        idNumbersOptions() {
            let options = [];
            let contractors = this.contractor > 0 ? [this.selectedContractor] : this.contractors;

            for (let contractor of contractors) {
                if (contractor.id_number.length) {
                    options.push({text: contractor.id_number, id: contractor.id + '-1'});
                }
                if (contractor.second_id_number.length) {
                    options.push({text: contractor.second_id_number, id: contractor.id + '-2'});
                }
            }

            options.sort((a, b) => a.text < b.text ? -1 : 1);
            options.unshift({text: '---', id: '0-0'});

            return options;
        },
        selectedIdNumber() {
            if (this.contractor === -1 || this.selectedIdNumberTypeOriginal == 'none')  return '0-0';

            return `${this.contractor}-${this.idNumber}`;
        },
        selectedIdNumberType() {
            let typeName = '';

            if(this.contractor !== -1 && this.idNumber === 1) {
                typeName = this.selectedContractor.id_number_type
            } else if(this.contractor !== -1 && this.idNumber === 2) {
                typeName = this.selectedContractor.second_id_number_type
            }

            return this.__(typeName);
        },
        selectedIdNumberTypeOriginal() {
            let typeName = '';

            if(this.contractor !== -1 && this.idNumber === 1) {
                typeName = this.selectedContractor.id_number_type
            } else if(this.contractor !== -1 && this.idNumber === 2) {
                typeName = this.selectedContractor.second_id_number_type
            }

            return typeName;
        },
    },
};
</script>
